import { generateApiUrl, generateLang } from "@/shared/utils";

/* eslint-disable no-console */
/* eslint-disable no-useless-catch */
import httpService from "@/shared/http";
import { pathOr } from "ramda";

export const addCenterExecutePerson = async ({
  centerExecuteId,
  personCenterExecutiveCode,
  personCenterExecutiveExecutiveCode,
  executiveRoleId,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecutePerson"],
      [centerExecuteId]
    );
    const payload = {
      person_center_execute_code: personCenterExecutiveCode,
      parvandeh_code: personCenterExecutiveExecutiveCode,
      executive_role_id: executiveRoleId,
    };
    const response = await httpService.post(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const updateCenterExecutePerson = async ({
  centerExecuteId,
  personCenterExecuteId,
  personCenterExecuteCode,
  parvandehCode,
  secondParvandehCode,
  executiveRoleId,
}) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecutePersonId"],
      [centerExecuteId, personCenterExecuteId]
    );
    const payload = {
      person_center_execute_code: personCenterExecuteCode,
      parvandeh_code: parvandehCode,
      second_assessor_parvandeh_code: secondParvandehCode,
      executive_role_id: executiveRoleId,
    };
    const response = await httpService.put(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const removeCenterExecutePerson = async (
  centerExecuteId,
  personCenterExecuteId
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecuteParvandehId"],
      [centerExecuteId, personCenterExecuteId]
    );
    const response = await httpService.delete(url);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
export const setCenterExecutePersonReport = async (
  centerExecuteCode,
  personId,
  isCreateReport
) => {
  try {
    const url = generateApiUrl(
      ["kanoon", "centerExecutePersonReport"],
      [centerExecuteCode, personId]
    );
    const payload = {
      is_create_report: isCreateReport,
    };
    const response = await httpService.patch(url, payload);
    const message = pathOr(null, ["data", "message"], response);

    return { message };
  } catch (error) {
    throw error;
  }
};
